module.exports = __webpack_public_path__ + "img/sierras2.58d3016.jpg";